module.exports = __webpack_public_path__ + "static/27-thumb-22aba525e058f2039e104c1a7eb06bc2.jpg";